import React, { useState, useEffect  } from "react";
import { Link, useLocation } from "react-router-dom";
import adminLogo from "../../../Assets/Images/AdminLogo.png";
import "./Sidebar.css";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import axios from "axios";

export default function Sidebar({ toggleSidebar }) {
  const location = useLocation();
  const [isSiteContentOpen, setIsSiteContentOpen] = useState(false);
  const [isChatSupporter, setChatSupporter] = useState(false);

  useEffect(() => {
    const loginDetails = JSON.parse(localStorage.getItem("loginDetails"));
    setChatSupporter(loginDetails?.roleId == 2 ? true: false);
  }, [isChatSupporter]);

  const toggleSiteContent = () => {
    setIsSiteContentOpen(!isSiteContentOpen);
  };
  const handleCloseSidebar = () => {
    // Close sidebar only if screen width is less than or equal to 768px (example for mobile view)
    if (window.innerWidth <= 768) {
      toggleSidebar();
    }
  };

  const logout = () => {
    confirmAlert({
      title: "Confirm Logout",
      message: "Are you sure you want to logout?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            setChatSupporter(false);
              localStorage.removeItem("loginDetails");
              // window.location.reload(true);
              window.location.href = '/';
              toast.success("Logged out successfully!");
              // <Navigate to="/" replace />
            // try {
            //   const baseURL = process.env.REACT_APP_API_URL;
            //   const loginDetails = JSON.parse(localStorage.getItem("loginDetails"));
            //   const userToken = loginDetails.token;
            //   const headers = {
            //     Authorization: `Bearer ${userToken}`,
            //   };

            //   const response = await axios.post(`${baseURL}/logout`, {}, {
            //     headers,
            //   });
            //   if(response){
            //     setChatSupporter(false);
            //     localStorage.removeItem("loginDetails");
            //     // window.location.reload(true);
            //     window.location.href = '/';
            //     toast.success("Logged out successfully!");
            //     // <Navigate to="/" replace />
            //   }
            // } catch (error) {
            //   toast.error("An error occurred during logout: " + error.message);
            // }
          },
        },
        {
          label: "No",
          // onClick: () => console.log("Logout cancelled"),
        },
      ],
    });
  };

  return (
    <section className="sidebarSection position-relative">

  
      <div className="logoSection p-2 pb-0 pt-0 d-flex justify-content-center">
        <img src={adminLogo} alt="logo" className="img-fluid" />
      </div>

      <div className="navbarSidbarLinks pt-3">
      {!isChatSupporter ? (
          <>
          <Link
            to="/dashboard/user-management"
            className={`nav-link ${
              location.pathname === "/dashboard/user-management" ? "active" : ""
            }`}
          >
            <div className="d-flex align-items-center py-3 border-bottom  px-4"  onClick={toggleSidebar}>
              <div className="navItemIconp pe-4">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.0587 15.521C17.5265 15.2015 18.0752 15.0211 18.6413 15.0004C19.2074 14.9798 19.7678 15.1199 20.2576 15.4044C20.7474 15.689 21.1466 16.1064 21.4091 16.6084C21.6716 17.1104 21.7865 17.6764 21.7407 18.241C20.5409 18.6603 19.2665 18.8235 17.9997 18.72C17.9958 17.5866 17.6695 16.4768 17.0587 15.522C16.5166 14.6718 15.7689 13.972 14.8846 13.4875C14.0003 13.003 13.0081 12.7493 11.9997 12.75C10.9916 12.7495 9.99957 13.0032 9.11547 13.4877C8.23137 13.9723 7.48374 14.6719 6.94174 15.522M17.9987 18.719L17.9997 18.75C17.9997 18.975 17.9877 19.197 17.9627 19.416C16.1481 20.4571 14.0918 21.0033 11.9997 21C9.82974 21 7.79274 20.424 6.03674 19.416C6.01103 19.1846 5.99868 18.9519 5.99974 18.719M5.99974 18.719C4.73337 18.8263 3.45965 18.6637 2.26074 18.242C2.21509 17.6776 2.33014 17.1117 2.59257 16.6099C2.855 16.1081 3.25411 15.6908 3.74374 15.4063C4.23338 15.1218 4.79354 14.9817 5.35946 15.0021C5.92538 15.0226 6.47395 15.2028 6.94174 15.522M5.99974 18.719C6.00333 17.5857 6.33136 16.4769 6.94174 15.522M14.9997 6.75C14.9997 7.54565 14.6837 8.30871 14.1211 8.87132C13.5585 9.43393 12.7954 9.75 11.9997 9.75C11.2041 9.75 10.441 9.43393 9.87842 8.87132C9.31581 8.30871 8.99974 7.54565 8.99974 6.75C8.99974 5.95435 9.31581 5.19129 9.87842 4.62868C10.441 4.06607 11.2041 3.75 11.9997 3.75C12.7954 3.75 13.5585 4.06607 14.1211 4.62868C14.6837 5.19129 14.9997 5.95435 14.9997 6.75ZM20.9997 9.75C20.9997 10.0455 20.9415 10.3381 20.8285 10.611C20.7154 10.884 20.5497 11.1321 20.3407 11.341C20.1318 11.5499 19.8838 11.7157 19.6108 11.8287C19.3378 11.9418 19.0452 12 18.7497 12C18.4543 12 18.1617 11.9418 17.8887 11.8287C17.6157 11.7157 17.3677 11.5499 17.1588 11.341C16.9498 11.1321 16.7841 10.884 16.671 10.611C16.5579 10.3381 16.4997 10.0455 16.4997 9.75C16.4997 9.15326 16.7368 8.58097 17.1588 8.15901C17.5807 7.73705 18.153 7.5 18.7497 7.5C19.3465 7.5 19.9188 7.73705 20.3407 8.15901C20.7627 8.58097 20.9997 9.15326 20.9997 9.75ZM7.49974 9.75C7.49974 10.0455 7.44154 10.3381 7.32847 10.611C7.2154 10.884 7.04966 11.1321 6.84073 11.341C6.6318 11.5499 6.38376 11.7157 6.11078 11.8287C5.8378 11.9418 5.54522 12 5.24974 12C4.95427 12 4.66169 11.9418 4.3887 11.8287C4.11572 11.7157 3.86768 11.5499 3.65875 11.341C3.44982 11.1321 3.28409 10.884 3.17101 10.611C3.05794 10.3381 2.99974 10.0455 2.99974 9.75C2.99974 9.15326 3.23679 8.58097 3.65875 8.15901C4.08071 7.73705 4.653 7.5 5.24974 7.5C5.84648 7.5 6.41877 7.73705 6.84073 8.15901C7.26269 8.58097 7.49974 9.15326 7.49974 9.75Z"
                    stroke={
                      location.pathname === "/dashboard/user-management"
                        ? "#16A34A"
                        : "#020223"
                    }
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="navLinkText">User management</div>
            </div>
          </Link>
          {/* <Link
            to="/dashboard/vpn-connection"
            className={`nav-link ${
              location.pathname === "/dashboard/vpn-connection" ? "active" : ""
            }`}
          >
            <div className="d-flex align-items-center py-3 border-bottom  px-4"  onClick={toggleSidebar}>
              <div className="navItemIconp pe-4">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.125 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.625M10.125 2.25H10.5C12.8869 2.25 15.1761 3.19821 16.864 4.88604C18.5518 6.57387 19.5 8.86305 19.5 11.25V11.625M10.125 2.25C11.0201 2.25 11.8785 2.60558 12.5115 3.23851C13.1444 3.87145 13.5 4.72989 13.5 5.625V7.125C13.5 7.746 14.004 8.25 14.625 8.25H16.125C17.0201 8.25 17.8786 8.60558 18.5115 9.23851C19.1444 9.87145 19.5 10.7299 19.5 11.625M9 15L11.25 17.25L15 12"
                    stroke={
                      location.pathname === "/dashboard/vpn-connection"
                        ? "#16A34A"
                        : "#020223"
                    }
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="navLinkText">Vpn connection</div>
            </div>
          </Link> */}
          <Link
            to="/dashboard/subscription"
            className={`nav-link ${
              location.pathname === "/dashboard/subscription" ? "active" : ""
            }`}
          >
            <div className="d-flex align-items-center py-3 border-bottom  px-4"  onClick={toggleSidebar}>
              <div className="navItemIconp pe-4">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.5 14.25V11.625C19.5 10.7299 19.1444 9.87145 18.5115 9.23851C17.8786 8.60558 17.0201 8.25 16.125 8.25H14.625C14.3266 8.25 14.0405 8.13147 13.8295 7.9205C13.6185 7.70952 13.5 7.42337 13.5 7.125V5.625C13.5 4.72989 13.1444 3.87145 12.5115 3.23851C11.8785 2.60558 11.0201 2.25 10.125 2.25H8.25M8.25 15H15.75M8.25 18H12M10.5 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.25C19.5 8.86305 18.5518 6.57387 16.864 4.88604C15.1761 3.19821 12.8869 2.25 10.5 2.25Z"
                    stroke={
                      location.pathname === "/dashboard/subscription"
                        ? "#16A34A"
                        : "#020223"
                    }
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="navLinkText">Subscription</div>
            </div>
          </Link>

          <div className="navbarSidbarLinks">
            <div
              onClick={toggleSiteContent}
              className={`nav-link cursor-pointer ${
                location.pathname.includes("/dashboard/site-content")
                  ? "active"
                  : ""
              }`}
            >
              <div className="d-flex align-items-center py-3 border-bottom  px-4"  onClick={toggleSidebar}>
                <div className="navItemIconp pe-4">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.5 14.25V11.625C19.5 10.7299 19.1444 9.87145 18.5115 9.23851C17.8786 8.60558 17.0201 8.25 16.125 8.25H14.625C14.3266 8.25 14.0405 8.13147 13.8295 7.9205C13.6185 7.70952 13.5 7.42337 13.5 7.125V5.625C13.5 4.72989 13.1444 3.87145 12.5115 3.23851C11.8785 2.60558 11.0201 2.25 10.125 2.25H8.25M12 11.25V17.25M15 14.25H9M10.5 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.25C19.5 8.86305 18.5518 6.57387 16.864 4.88604C15.1761 3.19821 12.8869 2.25 10.5 2.25Z"
                      stroke="#020223"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="navLinkText">Site Content</div>
                <svg
                  className="m-auto"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
            {isSiteContentOpen && (
              <ul className="list-group submenu">
                <li>
                  <Link
                    to="/dashboard/feature-listing"
                    className={`nav-link ${
                      location.pathname === "/dashboard/feature-listing"
                        ? "active"
                        : ""
                    }`}
                  >
                    <div className="d-flex align-items-center justify-content-center py-3 border-bottom  px-4"  onClick={toggleSidebar}>
                      <div className="navItemIconp">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.5 14.25V11.625C19.5 10.7299 19.1444 9.87145 18.5115 9.23851C17.8786 8.60558 17.0201 8.25 16.125 8.25H14.625C14.3266 8.25 14.0405 8.13147 13.8295 7.9205C13.6185 7.70952 13.5 7.42337 13.5 7.125V5.625C13.5 4.72989 13.1444 3.87145 12.5115 3.23851C11.8785 2.60558 11.0201 2.25 10.125 2.25H8.25M8.25 15H15.75M8.25 18H12M10.5 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.25C19.5 8.86305 18.5518 6.57387 16.864 4.88604C15.1761 3.19821 12.8869 2.25 10.5 2.25Z"
                            stroke={
                              location.pathname === "/dashboard/feature-listing"
                                ? "#16A34A"
                                : "#020223"
                            }
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="navLinkText ps-2">Feature Listing</div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/dashboard/header-content"
                    className={`nav-link ${
                      location.pathname === "/dashboard/header-content"
                        ? "active"
                        : ""
                    }`}
                  >
                    <div className="d-flex align-items-center justify-content-center py-3 border-bottom  px-4"  onClick={toggleSidebar}>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.25 6.087C14.25 5.732 14.436 5.411 14.651 5.128C14.872 4.838 15 4.494 15 4.125C15 3.089 13.993 2.25 12.75 2.25C11.507 2.25 10.5 3.09 10.5 4.125C10.5 4.494 10.628 4.838 10.849 5.128C11.064 5.411 11.25 5.732 11.25 6.087C11.2504 6.17275 11.2336 6.25771 11.2006 6.33684C11.1675 6.41596 11.1189 6.48764 11.0577 6.54762C10.9964 6.6076 10.9237 6.65465 10.8438 6.68598C10.764 6.71731 10.6787 6.73228 10.593 6.73C9.20166 6.68992 7.81271 6.58983 6.43 6.43C6.616 8.043 6.723 9.68 6.745 11.337C6.74593 11.4239 6.72958 11.5101 6.6969 11.5907C6.66422 11.6712 6.61587 11.7444 6.55465 11.8061C6.49343 11.8678 6.42056 11.9167 6.34028 11.95C6.26 11.9833 6.17391 12.0003 6.087 12C5.732 12 5.411 11.814 5.128 11.599C4.84137 11.3751 4.4887 11.2524 4.125 11.25C3.089 11.25 2.25 12.257 2.25 13.5C2.25 14.743 3.09 15.75 4.125 15.75C4.494 15.75 4.838 15.622 5.128 15.401C5.411 15.186 5.732 15 6.087 15C6.397 15 6.642 15.26 6.619 15.57C6.49461 17.2655 6.28031 18.9532 5.977 20.626C7.495 20.816 9.035 20.935 10.593 20.98C10.6787 20.9823 10.764 20.9673 10.8438 20.936C10.9237 20.9047 10.9964 20.8576 11.0577 20.7976C11.1189 20.7376 11.1675 20.666 11.2006 20.5868C11.2336 20.5077 11.2504 20.4227 11.25 20.337C11.25 19.982 11.064 19.661 10.849 19.378C10.6251 19.0914 10.5024 18.7387 10.5 18.375C10.5 17.34 11.508 16.5 12.75 16.5C13.993 16.5 15 17.34 15 18.375C15 18.744 14.872 19.088 14.651 19.378C14.436 19.661 14.251 19.982 14.251 20.337C14.251 20.67 14.528 20.936 14.861 20.917C16.6805 20.81 18.4924 20.5997 20.288 20.287C20.5597 18.7252 20.7539 17.151 20.87 15.57C20.8752 15.4969 20.8653 15.4236 20.8409 15.3545C20.8164 15.2854 20.778 15.2222 20.7279 15.1686C20.6779 15.1151 20.6173 15.0725 20.5501 15.0435C20.4828 15.0145 20.4103 14.9997 20.337 15C19.982 15 19.661 15.186 19.378 15.401C19.088 15.622 18.744 15.75 18.375 15.75C17.34 15.75 16.5 14.743 16.5 13.5C16.5 12.257 17.34 11.25 18.375 11.25C18.745 11.25 19.088 11.378 19.378 11.599C19.661 11.814 19.982 12 20.338 12C20.4249 12.0003 20.511 11.9833 20.5913 11.95C20.6716 11.9167 20.7444 11.8678 20.8057 11.8061C20.8669 11.7444 20.9152 11.6712 20.9479 11.5907C20.9806 11.5101 20.9969 11.4239 20.996 11.337C20.972 9.54486 20.8484 7.75544 20.626 5.977C18.74 6.319 16.816 6.551 14.86 6.666C14.7813 6.67037 14.7025 6.65858 14.6285 6.63137C14.5545 6.60416 14.4869 6.56209 14.4297 6.50777C14.3726 6.45344 14.3272 6.388 14.2963 6.31546C14.2653 6.24293 14.2496 6.16584 14.25 6.087Z"
                          stroke={
                            location.pathname === "/dashboard/header-content"
                              ? "#16A34A"
                              : "#020223"
                          }
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>

                      <div className="navItemIconp ">
                        {/* Icon for Header Content */}
                      </div>
                      <div className="navLinkText ps-2">Header Content</div>
                    </div>
                  </Link>
                </li>
              </ul>
            )}
          </div>

          <Link
            to="/dashboard/support"
            className={`nav-link ${
              location.pathname === "/dashboard/support" ? "active" : ""
            }`}
          >
            <div className="d-flex align-items-center py-3 border-bottom  px-4"  onClick={toggleSidebar}>
              <div className="navItemIconp pe-4">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.75 6.75002C21.7501 7.37337 21.6206 7.98993 21.3699 8.56063C21.1191 9.13132 20.7525 9.64369 20.2934 10.0653C19.8342 10.4868 19.2924 10.8084 18.7024 11.0096C18.1125 11.2108 17.4871 11.2872 16.866 11.234C15.79 11.143 14.602 11.305 13.916 12.138L6.76402 20.822C6.53841 21.097 6.25772 21.3217 5.94002 21.4817C5.62231 21.6417 5.27463 21.7334 4.91935 21.7509C4.56407 21.7684 4.20907 21.7113 3.87719 21.5833C3.54531 21.4553 3.24391 21.2592 2.99239 21.0077C2.74086 20.7561 2.54479 20.4547 2.41679 20.1228C2.28878 19.791 2.23169 19.436 2.24917 19.0807C2.26666 18.7254 2.35834 18.3777 2.51832 18.06C2.67829 17.7423 2.90301 17.4616 3.17802 17.236L11.862 10.084C12.695 9.39802 12.857 8.21002 12.766 7.13402C12.6989 6.35219 12.8374 5.5664 13.1677 4.85462C13.4981 4.14283 14.0088 3.52981 14.6492 3.07637C15.2896 2.62293 16.0375 2.34484 16.8186 2.2697C17.5997 2.19456 18.3869 2.32498 19.102 2.64802L15.826 5.92402C15.9528 6.47211 16.2309 6.97361 16.6286 7.3714C17.0264 7.76918 17.5279 8.04728 18.076 8.17402L21.352 4.89802C21.608 5.46302 21.75 6.09002 21.75 6.75002Z"
                    stroke={
                      location.pathname === "/dashboard/support"
                        ? "#16A34A"
                        : "#020223"
                    }
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4.86719 19.125H4.87519V19.133H4.86719V19.125Z"
                    stroke={
                      location.pathname === "/dashboard/support"
                        ? "#16A34A"
                        : "#020223"
                    }
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="navLinkText">Support</div>
            </div>
          </Link>
        </>
        ): null}
        {/* Chat panel start */}
        <Link
          to="/dashboard/chat"
          className={`nav-link ${
            location.pathname === "/dashboard/chat" ? "active" : ""
          }`}
        >
          <div className="d-flex align-items-center py-3 border-bottom  px-4"  onClick={toggleSidebar}>
            <div className="navItemIconp pe-4">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.625 9.75C8.625 9.84946 8.58549 9.94484 8.51517 10.0152C8.44484 10.0855 8.34946 10.125 8.25 10.125C8.15054 10.125 8.05516 10.0855 7.98484 10.0152C7.91451 9.94484 7.875 9.84946 7.875 9.75C7.875 9.65055 7.91451 9.55516 7.98484 9.48484C8.05516 9.41451 8.15054 9.375 8.25 9.375C8.34946 9.375 8.44484 9.41451 8.51517 9.48484C8.58549 9.55516 8.625 9.65055 8.625 9.75ZM8.625 9.75H8.25M12.375 9.75C12.375 9.84946 12.3355 9.94484 12.2652 10.0152C12.1948 10.0855 12.0995 10.125 12 10.125C11.9005 10.125 11.8052 10.0855 11.7348 10.0152C11.6645 9.94484 11.625 9.84946 11.625 9.75C11.625 9.65055 11.6645 9.55516 11.7348 9.48484C11.8052 9.41451 11.9005 9.375 12 9.375C12.0995 9.375 12.1948 9.41451 12.2652 9.48484C12.3355 9.55516 12.375 9.65055 12.375 9.75ZM12.375 9.75H12M16.125 9.75C16.125 9.84946 16.0855 9.94484 16.0152 10.0152C15.9448 10.0855 15.8495 10.125 15.75 10.125C15.6505 10.125 15.5552 10.0855 15.4848 10.0152C15.4145 9.94484 15.375 9.84946 15.375 9.75C15.375 9.65055 15.4145 9.55516 15.4848 9.48484C15.5552 9.41451 15.6505 9.375 15.75 9.375C15.8495 9.375 15.9448 9.41451 16.0152 9.48484C16.0855 9.55516 16.125 9.65055 16.125 9.75ZM16.125 9.75H15.75M2.25 12.76C2.25 14.36 3.373 15.754 4.957 15.987C6.044 16.147 7.142 16.27 8.25 16.356V21L12.434 16.817C12.6412 16.6107 12.9197 16.4918 13.212 16.485C15.1636 16.437 17.1105 16.2707 19.042 15.987C20.627 15.754 21.75 14.361 21.75 12.759V6.741C21.75 5.139 20.627 3.746 19.043 3.513C16.711 3.17072 14.357 2.99926 12 3C9.608 3 7.256 3.175 4.957 3.513C3.373 3.746 2.25 5.14 2.25 6.741V12.759V12.76Z"
                  stroke={
                    location.pathname === "/dashboard/chat"
                      ? "#16A34A"
                      : "#020223"
                  }
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="navLinkText">Chat</div>
          </div>
        </Link>
        <div
          className="nav-link d-flex align-items-center py-3 border-bottom  px-4 cursor-pointer"
          onClick={logout}
        >
          <div className="navItemIconp pe-4">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.25 9V5.25C8.25 4.65326 8.48705 4.08097 8.90901 3.65901C9.33097 3.23705 9.90326 3 10.5 3H16.5C17.0967 3 17.669 3.23705 18.091 3.65901C18.5129 4.08097 18.75 4.65326 18.75 5.25V18.75C18.75 19.3467 18.5129 19.919 18.091 20.341C17.669 20.7629 17.0967 21 16.5 21H10.5C9.90326 21 9.33097 20.7629 8.90901 20.341C8.48705 19.919 8.25 19.3467 8.25 18.75V15M5.25 15L2.25 12M2.25 12L5.25 9M2.25 12H15"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="navLinkText">Logout</div>
        </div>

        {/* <Link to="/dashboard/site-content" className={`nav-link ${location.pathname === "/dashboard/site-content" ? "active" : ""}`}>
          <div className="d-flex align-items-center py-3 border-bottom  px-4"  onClick={toggleSidebar}>
            <div className="navItemIconp pe-4">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5 14.25V11.625C19.5 10.7299 19.1444 9.87145 18.5115 9.23851C17.8786 8.60558 17.0201 8.25 16.125 8.25H14.625C14.3266 8.25 14.0405 8.13147 13.8295 7.9205C13.6185 7.70952 13.5 7.42337 13.5 7.125V5.625C13.5 4.72989 13.1444 3.87145 12.5115 3.23851C11.8785 2.60558 11.0201 2.25 10.125 2.25H8.25M8.25 15H15.75M8.25 18H12M10.5 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.25C19.5 8.86305 18.5518 6.57387 16.864 4.88604C15.1761 3.19821 12.8869 2.25 10.5 2.25Z"
                  stroke={location.pathname === "/dashboard/site-content" ? "#16A34A" : "#020223"}
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="navLinkText">Features</div>
          </div>
        </Link>
        <Link to="/dashboard/header-content" className={`nav-link ${location.pathname === "/dashboard/header-content" ? "active" : ""}`}>
          <div className="d-flex align-items-center py-3 border-bottom  px-4"  onClick={toggleSidebar}>
            <div className="navItemIconp pe-4">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5 14.25V11.625C19.5 10.7299 19.1444 9.87145 18.5115 9.23851C17.8786 8.60558 17.0201 8.25 16.125 8.25H14.625C14.3266 8.25 14.0405 8.13147 13.8295 7.9205C13.6185 7.70952 13.5 7.42337 13.5 7.125V5.625C13.5 4.72989 13.1444 3.87145 12.5115 3.23851C11.8785 2.60558 11.0201 2.25 10.125 2.25H8.25M8.25 15H15.75M8.25 18H12M10.5 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.25C19.5 8.86305 18.5518 6.57387 16.864 4.88604C15.1761 3.19821 12.8869 2.25 10.5 2.25Z"
                  stroke={location.pathname === "/dashboard/header-content" ? "#16A34A" : "#020223"}
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="navLinkText">Features</div>
          </div>
        </Link> */}
      </div>
    </section>
  );
}
